import { render } from "./base-footer.vue?vue&type=template&id=1e61a8ff&scoped=true&ts=true"
import script from "./base-footer.vue?vue&type=script&lang=ts"
export * from "./base-footer.vue?vue&type=script&lang=ts"

import "./base-footer.vue?vue&type=style&index=0&id=1e61a8ff&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e61a8ff"]])

export default __exports__